import React from 'react';
import PropTypes from 'prop-types';
import { Typography, useMediaQuery } from '@material-ui/core';

// STYLES
import { Container } from './styles';

const Question = ({ data }) => {
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  return (
    <Container className="question noselect">
      <div className="question__icon">
        <i className="icon-faq" />
      </div>
      <div className="question__content">
        <Typography
          className="question__question m-b-5"
          component="h5"
          variant={downXs ? 'h6' : 'h5'}
        >
          {data.question}
        </Typography>
        <Typography variant="subtitle2">{data.answer}</Typography>
      </div>
    </Container>
  );
};

Question.propTypes = {
  data: PropTypes.object.isRequired,
};

export default React.memo(Question);
